module.exports = __webpack_public_path__ + "static/media/face.d34a1009.svg";